import * as React from 'react';
import { cn } from '@/lib/utils.ts';
import { useSidebar } from './SidebarContext.tsx';

export const SIDEBAR_WIDTH = '12rem';

/**
 * Kolumna sidebara na szerokim ekranie. Poniżej `md` layout nie montuje jej
 * wcale — telefon dostaje `AppMobileMenu` z pastylką i arkuszem kafli.
 */
const Sidebar = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<'div'> & {
    side?: 'left' | 'right';
  }
>(({ side = 'left', className, children, ...props }, ref) => {
  const { state } = useSidebar();

  return (
    <div
      ref={ref}
      className="text-sidebar-foreground group peer hidden md:block"
      data-state={state}
      style={
        {
          '--sidebar-width': SIDEBAR_WIDTH,
        } as React.CSSProperties
      }
      data-side={side}
    >
      <div
        className={cn(
          'relative h-svh w-[--sidebar-width] bg-transparent transition-[width] duration-200 ease-linear',
        )}
      />
      <div
        className={cn(
          'fixed inset-y-0 z-10 hidden h-svh w-[--sidebar-width] transition-[left,right,width] duration-200 ease-linear md:flex',
          className,
        )}
        {...props}
      >
        <div
          data-sidebar="sidebar"
          className="flex h-full w-full flex-col bg-basic-white"
        >
          {children}
        </div>
      </div>
    </div>
  );
});
Sidebar.displayName = 'Sidebar';

export { Sidebar };
